// Renders a cropped region from any image URL into a fixed-size JPEG Blob.
// croppedAreaPixels comes from react-easy-crop's onCropComplete callback.
// Output dimensions match the 4:5 portrait ratio used in team cards.
const OUTPUT_W = 750;
const OUTPUT_H = 1000;

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () =>
      reject(
        new Error(
          "Could not load image for cropping. If this is an existing stored photo, " +
            "try replacing it with a fresh upload instead of re-cropping."
        )
      );
    img.src = src;
  });
}

export async function getCroppedBlob(
  imageSrc,
  croppedAreaPixels,
  outputWidth = OUTPUT_W,
  outputHeight = OUTPUT_H
) {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = outputWidth;
  canvas.height = outputHeight;
  const ctx = canvas.getContext("2d");

  // Fill white so semi-transparent edge pixels don't turn black in JPEG encoding.
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, outputWidth, outputHeight);

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    outputWidth,
    outputHeight
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error("Canvas export failed — browser may have blocked the operation."));
        }
      },
      "image/jpeg",
      0.92
    );
  });
}
